module.exports = __webpack_public_path__ + "static/media/incrowd1.a4c15adc.gif";